import { useSearchParams } from 'react-router-dom'
import { useAuth, RedirectToSignIn } from '@clerk/clerk-react'
import OutlineView from '../components/OutlineView'
import TeamGate from '../components/TeamGate'

export default function ProjectPage() {
  const { isSignedIn, isLoaded } = useAuth()
  const [searchParams] = useSearchParams()
  const recordId = searchParams.get('recordId')

  if (!isLoaded) return null
  if (!isSignedIn) return <RedirectToSignIn />

  return <TeamGate><OutlineView recordId={recordId} /></TeamGate>
}
